import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// material
import { Card, Stack, Container } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import { capitalise } from "../../utils/tableFunctions";
import { getSDDetailsDownload } from "../../services/deposit";
import TableView from "../Table";
import { getNextPage } from "../../services/services";

// ----------------------------------------------------------------------

export default function DepositList({ getAmount, table, setLoadedAmt }) {
  const [tableData, setTableData] = useState([]);
  const [next, setNext] = useState("");
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [csvData, setCsvData] = useState([]);

  const getNext = async () => {
    if (!next) return;
    const res = await getNextPage({
      url: next,
      filter: null,
    });
    let newRows = formatData(res);
    setTableData((old) => [...old, ...newRows]);
    setNext(res.next ? res.next : false);
  };
  const formatData = (input) => {
    let tableData = [];
    input.results.forEach(
      ({
        id,
        merchant,
        payout_date,
        hold_release,
        amount,
        payment_brand,
        currency,
      }) => {
        tableData.push({
          id: id,
          merchant_name: merchant.name,
          payout_date: payout_date,
          hold_release: capitalise(hold_release),
          payment_brand_name: payment_brand.name,
          currency: currency,
          deposit: hold_release.toLowerCase() === "hold" && amount,
          credit: hold_release.toLowerCase() === "release" && amount,
        });
      }
    );
    return tableData;
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const { id, currency } = useParams();

  useEffect(() => {
    let sum = {};
    for (let i = 0; i < table.count; i++) {
      if (table.results[i].hold_release === "hold") {
        var cur = table.results[i].currency;
        if (cur in sum) sum[cur] += parseFloat(table.results[i].amount);
        else sum[cur] = parseFloat(table.results[i].amount);
      }
    }
    getAmount(sum);
    setLoadedAmt(true);
    getSDDetailsDownload(id, currency, setCsvData);
  }, [id, currency, setLoadedAmt, table, getAmount]);

  const getCSVData = async () => {
    const data = await getSDDetailsDownload(id, currency);
    return data;
  };

  useEffect(() => {
    if (table) {
      setTableData(formatData(table));
      setNext(table.next);
    }
  }, [table]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        mb={3}
        spacing={2}
      ></Stack>

      <Card>
        <ListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          loaded={true}
          type={
            table.results.length > 0 ? `${table.results[0].merchant?.name}` : ""
          }
          filter={false}
          getCSVData={table.count > 0 ? getCSVData : false}
        />
        <Scrollbar>
          <TableView
            rows={tableData}
            link={`/3/app/details/reports`}
            getNext={getNext}
            count={table.count}
            query={filterName}
            urlId={["stt_report"]}
          />
        </Scrollbar>
      </Card>
    </Container>
  );
}
